import PDFCrossRefSection from 'PDFLib/core/document/PDFCrossRefSection';
import PDFHeader from 'PDFLib/core/document/PDFHeader';
import PDFTrailer from 'PDFLib/core/document/PDFTrailer';
import PDFTrailerDict from 'PDFLib/core/document/PDFTrailerDict';
import PDFDict from 'PDFLib/core/objects/PDFDict';
import PDFObject from 'PDFLib/core/objects/PDFObject';
import PDFRef from 'PDFLib/core/objects/PDFRef';
import PDFContext from 'PDFLib/core/PDFContext';
import PDFObjectStream from 'PDFLib/core/structures/PDFObjectStream';
import CharCodes from 'PDFLib/core/syntax/CharCodes';
import { copyStringIntoBuffer, waitForTick } from 'PDFLib/utils';
import {JSONObject} from "PDFLib/core/writers/JSONWriter/JSONObject";
import {PrecompiledJSONItem} from "PDFLib/core/writers/JSONWriter/JSONItem/PrecompiledJSONItem";
import {IndirectObjectJsonItem} from "PDFLib/core/writers/JSONWriter/JSONItem/IndirectObjectJsonItem";
import PDFWriter from "PDFLib/core/writers/PDFWriter";
import PDFName from "PDFLib/core/objects/PDFName";
import PDFContentStream from "PDFLib/core/structures/PDFContentStream";
import PDFRawStream from "PDFLib/core/objects/PDFRawStream";
import Stream from "PDFLib/core/streams/Stream";
import {DictionaryObjectItem} from "PDFLib/core/writers/JSONWriter/JSONItem/DictionaryObjectItem";
import {JSONFactory} from "PDFLib/core/writers/JSONWriter/JSONFactory";
import {PrecompiledStringJSONItem} from "PDFLib/core/writers/JSONWriter/JSONItem/PrecompiledStringJSONItem";
import {TrailerJsonItem} from "PDFLib/core/writers/JSONWriter/JSONItem/TrailerJsonItem";
import {PrecompiledRawStringItem} from "PDFLib/core/writers/JSONWriter/JSONItem/PrecompiledRawStringItem";
import {XRefItem} from "PDFLib/core/writers/JSONWriter/JSONItem/XRefItem";
import {PDFDocument} from "PDFLib/api";

export interface SerializationInfo {
  size: number;
  header: PDFHeader;
  indirectObjects: [PDFRef, PDFObject][];
  xref?: PDFCrossRefSection;
  trailerDict?: PDFTrailerDict;
  trailer: PDFTrailer;
}

class JSONWriter extends PDFWriter{
  static forContext = (context: PDFContext, objectsPerTick: number,document:PDFDocument=null) =>
    new JSONWriter(context, objectsPerTick,document);

  protected readonly context: PDFContext;
  protected Document:PDFDocument;
  protected constructor(context: PDFContext, objectsPerTick: number,document:PDFDocument) {
    super(context,500);
    this.Document=document;
    this.context=context;
  }


  public async ToObject(){


      const {
          size,
          header,
          indirectObjects,
          xref,
          trailerDict,
          trailer,
      } = await this.computeBufferSize();


      let json=new JSONObject();
      json.AddItem(new PrecompiledStringJSONItem(PDFHeader.forVersion(1, 7) as any));
      json.AddItem(new PrecompiledRawStringItem("\n\n"));
      let ref=[];


      for(let currentIndirectObject of indirectObjects)
      {
          let r:PDFRef;
          const [ref, object] = currentIndirectObject;
          json.AddItem(new IndirectObjectJsonItem(ref.objectNumber,ref.generationNumber,object));

      }

      if (xref) {
          json.AddItem(new XRefItem(xref));
      }

      if (trailerDict) {
          json.AddItem(new PrecompiledStringJSONItem(trailerDict as any));
      }
      json.AddItem(new TrailerJsonItem(trailer));
      return json;

  }

}

export default JSONWriter;
